<template>
    <app-wrapper>
        <app-header></app-header>
        <app-body>
            <slot v-if="isLoggedIn" />
            <lazy-loading-widget v-else></lazy-loading-widget>
        </app-body>
    </app-wrapper>
</template>

<script setup>
const {isLoggedIn} = storeToRefs(useStoreAuth());

function handleIsLoggedIn() {
    if (isLoggedIn.value === null) return useSeo().buildHeadLoading();
    if (isLoggedIn.value === false) {
        const $config = useRuntimeConfig();
        useSeo().buildHead({
            title: 'Login Required | ' + $config.public.companyName,
            description: 'You must sign in to view this page.',
        });
        return useRouter().replace({name: 'login'});
    }
}

watch(isLoggedIn, handleIsLoggedIn, {immediate: true});
</script>
